import { useSettings } from 'Settings'
import { Point, Bezier } from 'Vectorgraph/Point'
import Graph from '../Graph'
import ValueTransform from 'ValueTransform'

const STSGraph = () => {
	let graph = []

	const [settings] = useSettings()

	const lts_inital_voltage = settings['supervisory level']['lts initial voltage'].value
	const v_cs_acc = settings['cold-start accuracy']['v_cs_acc'].value
	const acc = settings['supervisory level']['v_lvl_acc'].value
	const sts_lts_always_connected = settings['supervisory']['always connect'].value
	const v_bat_max_hi = ValueTransform(settings['supervisory level']['v_bat_max_hi'].value, acc)
	const v_bat_min_hi_dis = ValueTransform(settings['supervisory level']['v_bat_min_hi_dis'].value, acc)
	const v_bat_max_lo = ValueTransform(settings['supervisory level']['v_bat_max_lo'].value, acc)
	const v_bat_min_lo = ValueTransform(settings['supervisory level']['v_bat_min_lo'].value, acc)
	const v_apl_max_lo = ValueTransform(settings['supervisory level']['v_apl_max_lo'].value, acc)
	const v_apl_max_hi = ValueTransform(settings['supervisory level']['v_apl_max_hi'].value, acc)

	let v_cs_hi = 0
	let v_cs_lo = 0

	if (v_cs_acc === 'MAX') {
		v_cs_hi = 1.369
		v_cs_lo = 1.169
	} else {
		v_cs_hi = 1.3
		v_cs_lo = 1.1
	}


	let lts_init = 0.65
	let lts_init_con = 1.2

	if (lts_inital_voltage === 1) {
		lts_init = 1.4
		lts_init_con = (v_bat_max_lo + v_bat_min_hi_dis) / 2
	}

	let lo
	if (v_apl_max_hi < v_bat_max_hi) {
		lo = v_apl_max_lo
	} else {
		lo = v_bat_max_lo
	}

	graph.push(Point(0, 0))

	if (sts_lts_always_connected) {
		graph.push(Bezier(0.1, lts_init_con, 0, lts_init_con))
		graph.push(Point(1, lts_init_con))
		graph.push(Point(2, v_bat_max_hi))
		graph.push(Point(2.5, v_bat_max_lo))
		graph.push(Point(3, v_bat_max_hi))

	} else {
		if (lts_inital_voltage === 1) {
			graph.push(Bezier(0.1, lts_init, 0, lts_init))
			graph.push(Point(0.2, lts_init))
			graph.push(Bezier(0.3, 0, 0.2, 0))
			graph.push(Point(0.4, 0))
			graph.push(Bezier(1, v_cs_hi, 0.5, v_cs_hi))
		} else {
			graph.push(Bezier(1, v_cs_hi, 0.25, v_cs_hi * 0.75))
		}

		graph.push(Point(1.25, lo))
		graph.push(Point(1.5, v_bat_min_hi_dis))
		graph.push(Point(1.75, lo))
		graph.push(Point(2, v_bat_min_hi_dis))
		graph.push(Point(2.25, v_bat_max_hi))
		graph.push(Point(2.5, v_bat_max_lo))
		graph.push(Point(2.75, v_bat_max_hi))
		graph.push(Point(3, v_bat_max_lo))
	}

	graph.push(Point(4, v_bat_min_lo))
	graph.push(Point(5, lo))
	graph.push(Point(5.5, (lo + v_bat_min_hi_dis) / 2))
	graph.push(Point(5.5, v_bat_min_hi_dis))
	graph.push(Point(6, lo))
	graph.push(Point(7, v_bat_max_hi))
	graph.push(Point(8, v_bat_min_lo))
	graph.push(Point(8.5, v_cs_lo))
	graph.push(Bezier(9, 0, 8.625, 0))
	return graph
}

const STS = (props) => {

	return (
		<Graph {...props} points={STSGraph()} />
	)
}

export default STS
export { STSGraph }
